import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import httpRequest from "../utils/Http";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { eagentId } = useParams();
  const [agentId, setAgentId] = useState(null);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);

  const validateFrom = (value) => {
    const errors = {};
    if (!value.password) {
      errors.password = "Enter password";
    } else if (value.password.length < 8) {
      errors.password = "Password must be 8 characters long";
    }

    if (value.password !== value.confirmPassword) {
      errors.confirmPassword = "Password does not match";
    }
    return errors;
  };

  useEffect(() => {
    if (eagentId) {
      setAgentId(atob(eagentId));
    } else {
      setAgentId(null);
    }
  }, [eagentId]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      (async () => {
        const data = await httpRequest(
          "resetpassword",
          {
            ...formData,
            agentId: agentId ? agentId : null,
          },
          "POST",
        );
        if (data.status === true && data.message) {
          setSubmit(false);

          toast.success("Password Reset Successfully");
        } else {
          toast.error(data.message);
          console.log(data.message);
        }
      })();
    }
    //eslint-disable-next-line
  }, [formErrors, isSubmit]);

  return (
    <div className="reset-password-shell">
      <div className="reset-password-box">
        <div className="card reset-password-card">
          <div className="card-header reset-password-header">
            <div className="reset-password-badge">
              <i className="fas fa-shield-alt"></i>
            </div>
            <div>
              <h3 className="reset-password-title">Reset Password</h3>
              <p className="reset-password-subtitle">
                Choose a secure password for your account.
              </p>
            </div>
          </div>

          <div className="card-body reset-password-body">
            <form
              onSubmit={onSubmitHandler}
              method="post"
              className="reset-password-form"
            >
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  New Password <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    id="password"
                    type="password"
                    className={`form-control ${formErrors.password ? "is-invalid" : ""}`}
                    placeholder="Enter new password"
                    name="password"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value,
                      });
                    }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="fas fa-lock"></i>
                    </span>
                  </div>
                </div>
                {formErrors.password && (
                  <div className="invalid-feedback d-block">
                    {formErrors.password}
                  </div>
                )}
              </div>

              <div className="form-group mb-4">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    id="confirmPassword"
                    type="password"
                    className={`form-control ${formErrors.confirmPassword ? "is-invalid" : ""}`}
                    placeholder="Re-enter your password"
                    name="confirmPassword"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        [e.target.name]: e.target.value,
                      });
                    }}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="fas fa-lock"></i>
                    </span>
                  </div>
                </div>
                {formErrors.confirmPassword && (
                  <div className="invalid-feedback d-block">
                    {formErrors.confirmPassword}
                  </div>
                )}
              </div>

              <div className="reset-password-actions">
                <Link
                  to="/"
                  className="btn btn-light reset-password-cancel-btn"
                >
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary reset-password-submit-btn"
                >
                  <i className="fas fa-check mr-2"></i>
                  Update Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
